<template>
  <svg class="v-icon__svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
    <path fill="currentColor" d="M3 8V6h9v2zm9-3H1V3h11zm1-2h6v6h-6zm-1 13H3v-2h9zm0-3H1v-2h11zm1-2h6v6h-6z" />
  </svg>
</template>
